export class TableFilter {
  private filters: { [name: string]: string } = {};

  setFilter(filterName: string, filterValue: string): void {
    if (filterValue === '') {
      delete this.filters[filterName];
    } else {
      this.filters[filterName] = filterValue;
    }
  }

  getFilters(): any {
    return this.filters;
  }

  reset(): void {
    this.filters = {};
  }

  hasFilters(): boolean {
    return Object.keys(this.filters).length !== 0;
  }
}
